

import { keys, reduce } from "lodash";
import { StageBReviewEndorse } from "../../../models/classes/stage-b/review-endorse.class";
import { InputError } from "../../../hooks/use-form";
import { SharedValidators } from "../shared/validators";


export const validateStageBReviewEndorse = (values: StageBReviewEndorse) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
  
      let validatedResult = validateStageBReviewEndorseFields(values, field);
      return { ...result, [field]: validatedResult };
    },{}
    );
  return errors;
};



export const validateStageBReviewEndorseFields = (values: any, name: string) => {
  const value = values[name];

  let error: InputError | undefined = { isValid: true };

  if(name === "input_verified"){
    error = SharedValidators.BasicBoolean(value);
  }
  return error;
};
